import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation } from "@swa-ui/browser";
import { swaDate } from "@swa-ui/date";

export function useVacationPackagesAnalytics(packageDataList) {
  const { pathname } = useLocation();
  const { setMktgPageData } = useContext(MktgDataContext);

  useEffect(() => {
    if (pathname === "/" || pathname.includes("/landing/home-page/")) {
      setMktgPageData(
        {
          content_moduledetails: getModuleDetails(),
        },
        "landingHomePage"
      );
    }
  }, [packageDataList.length]);

  function getModuleDetails() {
    return packageDataList
      ?.map((packageDataItem, index) => {
        const { packageData } = packageDataItem;
        const { flightOptions, hotelOption, prices } = packageData;
        const destination = flightOptions?.[0]?.arrival?.iataCode ?? "";
        const origin = flightOptions?.[0]?.departure?.iataCode ?? "";

        return [
          `${origin}:${destination}`,
          getPackageCostPerPax(prices),
          hotelOption?.hotelCode ?? "",
          hotelOption?.checkInDate ?? "",
          hotelOption?.duration,
          getBookingCurveDetails(hotelOption?.checkInDate),
          `${index + 1}|${packageDataList?.length}`,
        ].join(",");
      })
      .join(";");
  }

  function getPackageCostPerPax(prices) {
    let amount = 0;

    if (Array.isArray(prices) && prices[0]?.metadata?.label) {
      const label = prices[0].metadata.label.find((item) => item.code === "PACKAGE_COST_PER_PAX");

      amount = label?.cash?.amount ?? 0;
    }

    return amount;
  }

  function getBookingCurveDetails(departureDate) {
    return swaDate(departureDate).diff(swaDate(), "days");
  }
}
